import posthog from "posthog-js";

const POSTHOG_KEY = "phc_RBCnKSr7JPaZ9hH9rNi4nEhYaaTPDLleGpxXoXCAqZ1";
const POSTHOG_HOST = "https://eu.i.posthog.com";

let initialized = false;

/**
 * Boot PostHog on the client.
 * Safe to call multiple times — only initialises once.
 */
export function initPostHog() {
  if (initialized || !POSTHOG_KEY) return;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: true,        // auto page-views via history listener
    capture_pageleave: true,
    autocapture: true,             // auto-capture clicks, inputs, etc.
    persistence: "localStorage+cookie",
  });
  initialized = true;
}

/**
 * Link PostHog anonymous id → authenticated user.
 * Call after login / session restore.
 */
export function identifyUser(userId: string, traits?: Record<string, unknown>) {
  if (!POSTHOG_KEY) return;
  posthog.identify(userId, traits);
}

/**
 * Reset identity on sign-out.
 */
export function resetUser() {
  if (!POSTHOG_KEY) return;
  posthog.reset();
}

/**
 * Track a named event.
 */
export function capture(event: string, properties?: Record<string, unknown>) {
  if (!POSTHOG_KEY) return;
  posthog.capture(event, properties);
}

export { posthog };
